import React, { useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedScrollHandler, useSharedValue } from 'react-native-reanimated';
import { rem, Spacer, AppView, SCROLL_INDICATOR_INSETS, NavigationHeader } from 'design-system';
import Text from 'design-system/Text';
import RadioButton from 'design-system/RadioButton';
import Button, { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import useColors from 'hooks/useColors';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { useAppDispatch } from 'store/hooks';
import useNavigateToNextScreen from '../hooks/useNavigateToNextScreen';
const OPTIONS = [
    { value: 'STOCKS_AND_SHARES', title: 'Stocks & Shares ISA' },
    { value: 'CASH', title: 'Cash ISA' },
    { value: 'JISA', title: 'Junior ISA' },
    { value: 'LIFETIME_ISA', title: 'Lifetime ISA' },
];
const PickExistingISAAccounts = ({ route, navigation }) => {
    const colors = useColors();
    const dispatch = useAppDispatch();
    const scrollY = useSharedValue(0);
    const mountedOnAnotherScreen = route.params?.mountedOnAnotherScreen;
    const { paddingHorizontalStyle } = useAppFrameDimensions(mountedOnAnotherScreen);
    const contentContainerStyles = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    const navigateToNextScreen = useNavigateToNextScreen();
    const [selected, setSelected] = useState({});
    const selectedProducts = useMemo(() => Object.keys(selected).filter((product) => selected[product]), [selected]);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const handlePress = useCallback((value) => () => {
        setSelected((oldSelected) => ({ ...oldSelected, [value]: !oldSelected[value] }));
    }, []);
    const onSubmit = useCallback(() => {
        dispatch({ type: 'SAVE_ONBOARDING_STATE', accountsHeldElsewhere: selectedProducts });
        navigateToNextScreen();
    }, [selectedProducts, navigateToNextScreen]);
    const scrollHandler = useAnimatedScrollHandler(({ contentOffset }) => {
        scrollY.value = contentOffset.y;
    });
    const headerColors = useMemo(() => [colors.background.dark, colors.cards.onDark], [colors.background.dark, colors.cards.onDark]);
    return (<AppView withFrame={false}>
      <NavigationHeader scrollY={scrollY} regularTitleHeight outputColors={headerColors} isInTab={!!mountedOnAnotherScreen} rightContent={<View style={!!mountedOnAnotherScreen && staticStyles.rightBtnContainer}>
            <HelpScreenButton />
          </View>}/>
      <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} keyboardShouldPersistTaps="handled" contentContainerStyle={contentContainerStyles} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
        <ScreenInfoHeader title="Which ISAs do you currently hold?"/>

        {OPTIONS.map(({ value, title }) => (<TouchableBounceCard key={value} onDark noMarginTop onPress={handlePress(value)}>
            <View style={staticStyles.row}>
              <RadioButton type="multiple" isChecked={!!selected[value]}/>
              <Spacer w={16}/>
              <View style={staticStyles.flex}>
                <Text TextThin-14>{title}</Text>
              </View>
            </View>
          </TouchableBounceCard>))}
      </Animated.ScrollView>
      <Button brand floating title="Continue" onPress={onSubmit} isInTab={!!mountedOnAnotherScreen} disabled={!selectedProducts.length}/>
    </AppView>);
};
const staticStyles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: rem(16),
    },
    flex: {
        flex: 1,
    },
    rightBtnContainer: {
        marginRight: rem(16),
        marginBottom: rem(6),
        alignItems: 'flex-end',
    },
});
export default PickExistingISAAccounts;
